<template>
  <action-dispatcher
    action="product/getProduct"
    :parameters="$route.params.id"
    class="view-member-area-modules pb-9"
  >
    <step-title
      title="Conteúdo"
      description="Cadastre os módulos para o seu curso online"
    />

    <member-area-modules-content-header
      :modules="modules"
      :params="params"
      :final-quizz="final_quiz"
      @refresh="refresh"
      @copy-module="modal = true"
    />

    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>

    <member-area-modules-empty v-else-if="!modules.length && !final_quiz" />

    <template v-else>
      <draggable-modules
        v-model="sortedModules"
        @reorder-nested="reorderNested"
        @reorder-lessons="reorderLessons"
        @edit-module="editModule"
        @edit-submodule="editModule"
        @edit-lesson="editLesson"
        @edit-quizz="editQuizz"
        @duplicate-module="duplicateModule"
        @duplicate-lesson="duplicateLesson"
        @duplicate-submodule="duplicateModule"
        @remove-module="removeModule"
        @remove-submodule="removeSubmodule"
        @remove-lesson="removeLesson"
        @remove-quizz="removeQuizz"
      />

      <template v-if="final_quiz">
        <hr />
        <final-quizz-item :quiz="final_quiz" @refresh="dispatchFinalQuizz" />
      </template>
    </template>
    <responsive-modal v-model="modal">
      <clone-module @close="modal = false" @refresh="refresh" />
    </responsive-modal>
    <confirmation
      iconType="warning"
      title="Aviso"
      cancelButtonText="Cancelar"
      v-model="removeConfirmation"
      :newDesign="true"
      confirmButtonClass="btn-danger"
      confirmButtonText="Excluir"
      :text="confirmationMessage"
      @confirm="modalAction('confirm')"
      @cancel="modalAction('cancel')"
    />
  </action-dispatcher>
</template>

<script>
import CloneModule from "@/components/product/details/content/CloneModule";
import DraggableModules from "@/components/product/details/content/DraggableModules";
import MemberAreaModulesContentHeader from "@/components/product/details/content/modules/MemberAreaModulesContentHeader";
import MemberAreaModulesEmpty from "@/components/product/details/content/modules/MemberAreaModulesEmpty";
import FinalQuizzItem from "@/components/product/details/content/modules/quizz/FinalQuizzItem";
import MemberAreaMixin from "@/mixins/memberArea.js";
import MemberAreaEventHandlersMixin from "@/mixins/memberAreaEventHandlers.js";
import ProductActionsMixin from "@/mixins/productActions.js";
import { mapState } from "vuex";

let timeout;
export default {
  mixins: [ProductActionsMixin, MemberAreaMixin, MemberAreaEventHandlersMixin],
  components: {
    MemberAreaModulesContentHeader,
    MemberAreaModulesEmpty,
    DraggableModules,
    FinalQuizzItem,
    CloneModule
  },
  data() {
    return {
      params: {
        product_id: this.$route.params.id,
        offset: 0,
        limit: 1000,
        search: ""
      },
      final_quiz: null,
      loading: false,
      search: "",
      editedIndex: null,
      modal: false,
      removeConfirmation: false,
      itemToRemove: {},
      confirmationMessage: ""
    };
  },
  computed: {
    ...mapState("product", ["product"]),
    ...mapState("membersModules", ["modules", "pagination"]),
    sortedModules: {
      get() {
        return [...this.modules].sort((a, b) => a.sort - b.sort);
      },
      set(val) {
        for (let i in val) {
          val[i].sort = i;
          val[i].parent = null;
          for (let j in val[i].sub_modules) {
            val[i].sub_modules[j].sort = j;
            val[i].sub_modules[j].parent = val[i].id;
          }
        }
        this.$store.commit("membersModules/setModules", val);
        this.saveOrder();
      }
    },
    breadcrumbs() {
      return [
        { link: "product", title: "Meus produtos" },
        {
          link: "product-details",
          title: this.product ? this.product["name"] : "...",
          params: { id: this.$route.params.id }
        },
        {
          title: "Conteúdo"
        }
      ];
    }
  },
  mounted() {
    this.dispatch();
    this.dispatchFinalQuizz();
    this.getMemberAreaSetup();
  },
  methods: {
    searching(v) {
      this.search = v;
    },
    refresh() {
      this.dispatch();
    },
    dispatchFinalQuizz() {
      this.$store
        .dispatch("membersQuizzes/getQuizzFinal", this.$route.params.id)
        .then(data => {
          this.final_quiz = data.final_quiz;
        });
    },
    dispatch() {
      this.loading = true;
      this.$store
        .dispatch("membersModules/get", this.params)
        .then()
        .finally(() => {
          this.loading = false;
        });
    },
    modalAction(action) {
      if (action === "confirm") this.removeItem(this.itemToRemove);
      else {
        this.itemToRemove = null;
        this.removeConfirmation = false;
      }
    }
  },
  watch: {
    "params.search"() {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        this.dispatch();
      }, 300);
    }
  }
};
</script>

<style lang="scss">
.view-member-area-modules {
  a {
    text-decoration: none;
  }

  .box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid #d2d0d8;
    border-radius: 4px;
    height: 232px;
    cursor: pointer;
    img {
      height: 54px;
      width: 54px;
    }

    &:hover {
      background: linear-gradient(148.5deg, #ee6469 -19.31%, #5576ec 100%);
      border-color: rgb(191, 92, 170);

      strong {
        color: white;
      }
    }
  }

  .handle {
    cursor: grab;
  }

  .btn {
    white-space: nowrap;
  }

  .countStudents {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: rgba(82, 0, 205, 0.9);
  }

  .dropdown-toggle {
    background-color: unset !important;
    min-height: 40px;
    padding: 0 16px;
    border: unset !important;

    &::after {
      content: none;
    }
  }

  hr {
    border-top: 1px solid #f0eff2;
    border-radius: 8px;
  }
}
</style>
